import { decodeModelId } from './globalIdHelper';

const experimental = path => `/experimental${path}`;

const showPath = path => `${path}/:id`;
const newPath = path => `${path}/new`;

export const modelPath = (basePath, model) =>
  `${basePath}/${decodeModelId(model)}`;

// react-router uses path-to-regexp, should we use it as well in a future?
// https://github.com/pillarjs/path-to-regexp/tree/v1.7.0#compile-reverse-path-to-regexp
export const resolvePath = (path, params) =>
  Object.entries(params).reduce(
    (memo, [key, value]) => memo.replace(key, value),
    path
  );

export const ovalContentsApiPath = '/api/v2/compliance/oval_contents';

export const ovalContentsPath = experimental('/compliance/oval_contents');
export const ovalContentsShowPath = showPath(ovalContentsPath);
export const ovalContentsNewPath = newPath(ovalContentsPath);
export const ovalPoliciesPath = experimental('/compliance/oval_policies');
export const ovalPoliciesShowPath = `${showPath(ovalPoliciesPath)}/:tab?`;
export const ovalPoliciesNewPath = newPath(ovalPoliciesPath);
export const hostsPath = '/hosts';
export const newJobPath = newPath('/job_invocations');
export const hostsShowPath = showPath(hostsPath);



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/helpers/pathsHelper.js